import { HOME_ROUTE } from '../../web-routes';

import { LocalStorageController } from '../../util/local-storage-controller';
import { getHistory } from '../../widgets/browser-history-spy';

const REDIRECT_URL_KEY = 'REDIRECT_URL_KEY';
const REDIRECT_CONTEXT = 'REDIRECT_CONTEXT';

export class RedirectUrl {
  static saveRedirectContext = (context: any) => {
    LocalStorageController.setItem(REDIRECT_CONTEXT, JSON.stringify(context));
  };

  static getRedirectContext = () => {
    const context = LocalStorageController.getItem(REDIRECT_CONTEXT) || '{}';
    return JSON.parse(context);
  };

  static clearRedirectContext = () => {
    LocalStorageController.removeItem(REDIRECT_CONTEXT);
  };

  static saveRedirectUrl = (url: string) => {
    LocalStorageController.setItem(REDIRECT_URL_KEY, url);
  };

  static navigateToRedirectUrl = () => {
    const route = LocalStorageController.getItem(REDIRECT_URL_KEY) || HOME_ROUTE;
    LocalStorageController.removeItem(REDIRECT_URL_KEY);
    const history = getHistory();
    history.push(route);
  };
}
